import { render, staticRenderFns } from "./comment-list-dialog.vue?vue&type=template&id=62f1f25e&"
import script from "./comment-list-dialog.vue?vue&type=script&lang=js&"
export * from "./comment-list-dialog.vue?vue&type=script&lang=js&"
import style0 from "./comment-list-dialog.vue?vue&type=style&index=0&id=62f1f25e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports